/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Allocationamount_Required2Inputs */

const en_coinvestments_allocationamount_required2 = /** @type {(inputs: Coinvestments_Allocationamount_Required2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation amount is required`)
};

/**
* | output |
* | --- |
* | "Allocation amount is required" |
*
* @param {Coinvestments_Allocationamount_Required2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_allocationamount_required2 = /** @type {((inputs?: Coinvestments_Allocationamount_Required2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Allocationamount_Required2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_allocationamount_required2(inputs)
});
export { coinvestments_allocationamount_required2 as "coInvestments_allocationAmount_required" }